import { put } from "redux-saga/effects";
import { FormsService, GetFormResponse, GetTransferFormResponce } from "../../../services/forms";
import { setUserToken } from "../../auth/actionCreators";
import { IForm, TransferFormActionType } from "../types";
import {
    getUserFontsRequest,
    initFormButtons,
    setCurrentForm,
    setFormStyles,
    setTransferFormData,
} from "../actionCreators";
import { InitPages } from "../../pages/actionCreators";
import {
    completeFieldsData,
    completeFormButtonsStyles,
    completeFormSetting,
    completeFormStyles,
    getCompletedPaymentData,
} from "../../../helpers/dataManipulations";
import { initFormSettings } from "../../settings/actionCreators";
import { initFields } from "../../fields/actionCreators";
import { initLayout } from "../../layout/actionCreators";
import { initMarkers } from "../../markers/actionCreaters";
import { initUI } from "../../ui/actionCreators";
import { initOptions } from "../../selectableOptions/actionCreaters";
import { initConfigs } from "../../configs/actionCreators";
import { initValidationMessages } from "../../validations/actionCreators";
import { initPayableFields, initPaymentData } from "../../payment/actionCreators";
import { getDeclarableFormButtonsData } from "../../../helpers/submitButton";
import { getDeclarablePaymentData } from "../../../helpers/paymentActions";

export function* transferFormSaga({ payload }: TransferFormActionType) {
    try {
        const { instance, compId } = payload;
        const {
            data: { data },
        }: GetTransferFormResponce = yield FormsService.transferForm(instance, compId);

        if (!data.formId) {
            throw Error("FORM ID IS NOT PROVIDED FROM BE");
        }
        const { pageFields, userInfo, formId, fields } = data;
        yield put(setUserToken({ token: userInfo.token, refresh_token: userInfo.refresh_token }));
        const {
            data: { data: currForm },
        }: GetFormResponse = yield FormsService.getForm(formId);
        yield put(
            setCurrentForm({
                _id: currForm._id,
                name: currForm.name,
                status: currForm.status,
                createdAt: currForm.createdAt,
                updatedAt: currForm.updatedAt,
            } as IForm),
        );
        yield put(InitPages({ list: currForm.pages }));
        yield put(initFormSettings(completeFormSetting(currForm.settings)));
        yield put(setFormStyles(completeFormStyles(currForm.styles)));
        yield put(initFields({ list: completeFieldsData(currForm.fields) }));
        yield put(initLayout(currForm.layout));
        yield put(initMarkers({ list: currForm.fields }));
        yield put(initUI({ isPaginationActive: currForm.isPaginationActive, isVerticalView: currForm.isVerticalView }));
        yield put(initOptions({ list: data.fields }));
        yield put(initConfigs(currForm));
        yield put(getUserFontsRequest({}));
        yield put(initValidationMessages(currForm.validations));
        yield put(initPayableFields({ list: data.fields, paymentSettings: currForm.paymentSettings! }));
        yield put(initFormButtons(getDeclarableFormButtonsData(completeFormButtonsStyles(currForm.styles.buttons))));
        yield put(
            initPaymentData(
                getDeclarablePaymentData(
                    getCompletedPaymentData(currForm.paymentSettings ? currForm.paymentSettings : {}),
                ),
            ),
        );
        yield put(
            setTransferFormData({ fields, pages: pageFields, logic: data.newLogic || [], wixFields: data.wixFields }),
        );
    } catch (e) {
        console.log("Inside transfser saga ", e);
    }
}
